import isString from 'lodash-es/isString';

/**
 * Cross browser date converted copied from angular date filter.
 *
 * @param  {string} string Date string
 * @return {data|string}   Date object or source string if format not matched
 */
export function jsonStringToDate(string: string): Date | undefined {
    if (typeof string === 'string' && string.length) {
        // Chack ISO date format
        const R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
        //                      1        2       3         4          5          6          7          8  9     10      11
        let match = string.match(R_ISO8601_STR);

        if (match) {
            const date = new Date(0);
            let tzHour = 0;
            let tzMin = 0;
            const dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear;
            const timeSetter = match[8] ? date.setUTCHours : date.setHours;

            if (match[9]) {
                tzHour = toInt(match[9] + match[10]);
                tzMin = toInt(match[9] + match[11]);
            }

            dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));

            const h = toInt(match[4] || 0) - tzHour;
            const m = toInt(match[5] || 0) - tzMin;
            const s = toInt(match[6] || 0);
            const ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);

            timeSetter.call(date, h, m, s, ms);

            return date;
        }

        // Check MYSQL datetime formt YYYY-MM-DD hh:mm:ss
        const R_MYSQL_STR = /^([0-9]{2,4})-([0-1][0-9])-([0-3][0-9])(?:( [0-2][0-9]):([0-5][0-9]):([0-5][0-9]))?$/;
        match = string.match(R_MYSQL_STR);

        if (match) {
            const date = new Date(0);
            const dateSetter = date.setFullYear;
            const timeSetter = date.setHours;

            dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));

            const h = toInt(match[4] || 0);
            const m = toInt(match[5] || 0);
            const s = toInt(match[6] || 0);

            timeSetter.call(date, h, m, s);

            return date;
        }
    }

    function toInt(str: string | number): number {
        return typeof str === 'string' ? parseInt(str, 10) : str;
    }
}
